import mobiusModule from "@stoneage/MobiusOverrides/LazyImage/LazyImage";

export * from "@stoneage/MobiusOverrides/LazyImage/LazyImage";
export default mobiusModule;
